export default __webpack_public_path__ + "static/media/inbrain.39250735.png";